import type { SearchParamsRecord } from '../queryParams';
import { Effect, Exit, Schema } from 'effect';

import { AlphabetFilterSchema } from './alphabetFilter';

export { AlphabetFilterSchema };

// Brand name search filter (any non-empty string)
export const SearchFilterSchema = Schema.String.check(Schema.isNonEmpty()).annotate({
  identifier: 'SearchFilterSchema',
  description: 'Brand name search filter',
});

// Combined brand filters schema with optional fields that default to null.
// v4: `withDecodingDefaultTypeKey` covers the decoding path; pair it with
// `withConstructorDefault` so `BrandFiltersSchema.make({})` works at runtime.
export const BrandFiltersSchema = Schema.Struct({
  alphabet: Schema.NullOr(AlphabetFilterSchema).pipe(
    Schema.withDecodingDefaultTypeKey(Effect.succeed(null)),
    Schema.withConstructorDefault(Effect.succeed(null))
  ),
  search: Schema.NullOr(SearchFilterSchema).pipe(
    Schema.withDecodingDefaultTypeKey(Effect.succeed(null)),
    Schema.withConstructorDefault(Effect.succeed(null))
  ),
});

export type BrandFilters = Schema.Schema.Type<typeof BrandFiltersSchema>;

/**
 * Decode brand filter search params with Either pattern for safe parsing
 * Returns null for missing/invalid filters
 */
export const decodeBrandFiltersSearchParams = (searchParams: SearchParamsRecord) => {
  const decodeQueryParams = Schema.decodeUnknownExit(BrandFiltersSchema);
  const filtersResult = decodeQueryParams(searchParams);

  const parsed = Exit.match(filtersResult, {
    onFailure: () => BrandFiltersSchema.make({}),
    onSuccess: (v) => v,
  });

  return {
    alphabetFilter: parsed.alphabet,
    searchFilter: parsed.search,
  };
};
